import React from 'react';
import { registrationSettingsSelector } from '../../store/reducers/registrationSettingsReducer';
import { useSelector } from 'react-redux';

function AlreadyRegistered() {
    const registrationData = useSelector(registrationSettingsSelector);

    return (
        <div className="registered_container">
            <div> 
                <h2>{registrationData.already_registered_title}</h2>
                <div>               
                    <h4>{registrationData.already_registered_service_title}</h4>
                    <p>{registrationData.already_registered_service_description}</p>
                </div>
                <div className="lastDiv">
                    <h4>{registrationData.already_registered_contact_title}</h4>
                    <p>{registrationData.already_registered_contact_text}</p>
                    <p><a className="links" href={"mailto: " + registrationData.already_registered_email}>{registrationData.already_registered_email}</a></p>
                    <p className="bottom-p">{registrationData.already_registered_phone}</p>
                </div>
                <a href="/"><button className="returnHome">{registrationData.already_registered_return}</button></a>
            </div>
        </div>
    );
}

export default AlreadyRegistered;
